import { TableDataQa } from 'commons/types/enums'
import { SortDirection, Table } from 'ui/components/Table'

import { useClientPortalReportContext } from '../../context/reportContext'
import { columns } from './columns'

export const ReportTable = () => {
  const {
    data: {
      form: { page, size, sortBy, sortDesc },
      total,
      items
    },
    routeApi,
    isFetching
  } = useClientPortalReportContext()
  const navigate = routeApi.useNavigate()

  return (
    <Table
      columns={columns}
      dataSource={items.map((item) => ({ item }))}
      dataQa={TableDataQa.BP_REPORTS_CLIENT_USERS_ACTIVITY_REPORT}
      loading={isFetching}
      pagination={{
        page,
        size,
        onChange: (page, size) => {
          navigate({ to: '.', search: (prev) => ({ ...prev, page, size }) })
        },
        total
      }}
      sorting={{
        order: [
          {
            field: sortBy || '',
            direction: sortDesc ? 'DESC' : 'ASC'
          }
        ],
        onChange: ({ field, direction }) => {
          navigate({
            to: '.',
            search: (prev) => ({ ...prev, sortBy: field, sortDesc: direction === SortDirection.DESC })
          })
        }
      }}
    />
  )
}
